import React, { useState, useMemo } from "react";
import PageLoader from "../components/ui/PageLoader";
import "../assets/css/style.css";
import { useGetPageVisitsQuery } from "apis/pageVisit";
import { formatDate } from "utils/helperFunctions";
import Table from "components/ui/Table";

const PageVisits = () => {
  const pageSize = 10;

  const {
    data,
    isPending: isDataPending,
    isError: isDataError,
    error: dataError,
  } = useGetPageVisitsQuery();

  const columns = useMemo(
    () => [
      {
        accessorKey: "index",
        header: "#",
        cell: (_, rowIndex, currentPage) =>
          (currentPage - 1) * pageSize + rowIndex + 1,
        isFilter: false,
        isSortable: false,
      },
      {
        accessorKey: "device",
        header: "Device",
        cell: (row) => (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${
              row.device === "mobile"
                ? "bg-blue-100 text-blue-800"
                : row.device === "desktop"
                ? "bg-green-100 text-green-800"
                : "bg-purple-100 text-purple-800"
            }`}
          >
            {row.device || "Unknown"}
          </span>
        ),
        isFilter: true,
      },
      {
        accessorKey: "browser",
        header: "Browser",
        cell: (row) => (
          <span className="capitalize">{row.browser || "-"}</span>
        ),
        isFilter: true,
      },
      {
        accessorKey: "os",
        header: "OS",
        cell: (row) => (
          <span className="capitalize">{row.os || "-"}</span>
        ),
        isFilter: true,
      },
      {
        accessorKey: "country",
        header: "Country",
        cell: (row) => (
          <span className="font-medium uppercase">
            {row.country || "-"}
          </span>
        ),
        isFilter: true,
      },
      {
        accessorKey: "region",
        header: "Region",
        cell: (row) => (
          <span className="uppercase">{row.region || "-"}</span>
        ),
        isFilter: true,
      },
      {
        accessorKey: "city",
        header: "City",
        cell: (row) => <span>{row.city || "-"}</span>,
        isFilter: true,
      },
      {
        accessorKey: "createdAt",
        header: "Visited At",
        cell: (row) => (
          <span className="text-sm">
            {formatDate(row.createdAt)}
          </span>
        ),
        isFilter: false,
      },
    ],
    []
  );

  if (isDataPending) {
    return <PageLoader />;
  }

  const CustomHeader = () => (
    <div className="flex items-center gap-4 bg-lightgray p-6 rounded-lg mb-6 text-center">
      <h2 className="text-3xl font-bold">
        {data?.length || 0}
      </h2>
      <p className="text-lg">Total Page Visits</p>
    </div>
  );

  return (
    <div className="container mx-auto">
      <CustomHeader />
      <Table
        title="Page Visits"
        columns={columns}
        data={data || []}
        pageSize={pageSize}
      />
    </div>
  );
};

export default PageVisits;